import { Mark, TikTokIcon } from './Mark';
import { Reveal } from './Reveal';

export default function Footer() {
  return (
    <footer className="border-t border-ivory/10 bg-plum-deep" data-testid="footer">
      <div className="mx-auto max-w-[1280px] px-6 py-16">
        <Reveal>
          <a
            href="#"
            data-testid="footer-hashtag"
            className="block font-display uppercase leading-none tracking-wide text-gold transition-colors duration-300 hover:text-mauve"
            style={{ fontSize: 'clamp(3rem, 10vw, 8.5rem)' }}
          >
            #itsFunkyBaby
          </a>
        </Reveal>
        <div className="mt-10 flex flex-wrap items-center justify-between gap-6 border-t border-ivory/10 pt-8">
          <div className="flex items-center gap-3">
            <Mark size={30} spin />
            <span className="font-mono text-[13px] tracking-[0.15em] text-sky">@princessnyah · itsfunkybaby.co.uk</span>
          </div>
          <span className="font-mono text-[12px] uppercase tracking-[0.2em] text-ivory/50">
            New episodes · Mondays · 6PM GMT
          </span>
          <a
            href="https://www.tiktok.com/@princessnyahandstuff"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="It's Funky Baby on TikTok"
            data-testid="footer-tiktok-link"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-ivory/20 text-ivory transition-[border-color,color,transform] duration-200 hover:scale-110 hover:border-gold hover:text-gold"
          >
            <TikTokIcon size={18} />
          </a>
        </div>
      </div>
    </footer>
  );
}
